/* eslint-disable react/prop-types */
import Flex from 'components/common/Flex';
import TooltipComponent from 'components/wise-components/TooltipComponent';
import { thousandSeparator } from 'helpers/helper';
import React, { useState } from 'react';
import { Button, Col, Offcanvas, Row } from 'react-bootstrap';
import PayRadioInput from 'components/wise-components/PayRadioInput';
import wiseLogo from '../../assets/img/wise.png';

const ReviewItem = ({ className = 'mb-1', title, value }) => {
  return (
    <Flex alignItems="center" justifyContent="between" className={className}>
      <p className="mb-0">{title}</p>
      <p className="mb-0">{value}</p>
    </Flex>
  );
};

function PayTransfer() {
  const [show, setShow] = useState(false);
  const [paymentType, setPaymentType] = useState('debit_card');

  const items = [
    {
      id: 1,
      value: 'debit_card',
      title: 'Debit card',
      subText1: 'Send from your Visa or Mastercard.',
      subText2: 'Should arrive in 15 minutes.'
    },
    {
      id: 2,
      title: 'Credit card',
      value: 'credit_card',
      subText1: 'Send from your Visa or Mastercard.',
      subText2: 'Should arrive in 15 minutes.'
    }
  ];

  const lowCostItem = [
    {
      id: 3,
      value: 'manually',
      title: 'Manually transfer the money from your bank',
      subText1: 'Manually transfer the money to Wise using your bank.',
      subText2: 'Should arrive in 5 hours.'
    }
  ];

  const notAvailablePaymentOptions = [
    {
      id: 3,
      value: 'wise_account',
      title: 'Your Wise account',
      subText1: 'You only have 2,426.65 PLN in your balance.'
    }
  ];

  console.log(paymentType);

  return (
    <>
      <Row>
        <Col lg={7} xl={7}>
          <div>
            <p className="fs-2 fw-semi-bold text-1000 mb-5">
              Choose your transfer type
            </p>

            <>
              <p className="text-1000">
                Fast and easy transfer
                <TooltipComponent
                  icon="question-circle"
                  text="some text will be here"
                  size="1x"
                />{' '}
                - 98.25 PLN in total fees
              </p>
              <hr />
              <div className="mt-4">
                <PayRadioInput
                  options={items}
                  data={paymentType}
                  setData={setPaymentType}
                  className="mb-4"
                />
              </div>
            </>
            <>
              <p className="text-1000">
                Low cost transfer
                <TooltipComponent
                  icon="question-circle"
                  text="98.25 PLN in total fees"
                  size="1x"
                />{' '}
                - 98.25 PLN in total fees
              </p>
              <hr />
              <div className="mt-4">
                <PayRadioInput
                  options={lowCostItem}
                  data={paymentType}
                  setData={setPaymentType}
                  className="mb-4"
                  icon="home"
                />
              </div>
            </>
            <>
              <p className="text-1000">Not available</p>
              <hr />
              <div className="mt-4">
                <PayRadioInput
                  options={notAvailablePaymentOptions}
                  data={paymentType}
                  setData={setPaymentType}
                  className="mb-4"
                  image={wiseLogo}
                  disable
                />
              </div>
            </>
          </div>
        </Col>
        <Col className="d-none d-xl-block" xl={1} />
        <Col lg={5} xl={4}>
          <div className="border rounded-4 p-3">
            <p className="fs-1 fw-semi-bold text-1000">Transfer details</p>
            <div>
              <ReviewItem
                className="mb-2"
                title="You send exactly"
                value={
                  <span className="mb-0 fs-1 fw-semi-bold text-1000">
                    {thousandSeparator(5000)} PLN
                  </span>
                }
              />
              <ReviewItem
                title="Total fees (included)"
                value={
                  <span className="mb-0">{thousandSeparator(98.25)} PLN</span>
                }
              />
              <ReviewItem
                title="Total amount we'll convert"
                value={
                  <span className="mb-0">{thousandSeparator(4901.75)} PLN</span>
                }
              />
              <Flex
                alignItems="center"
                justifyContent="between"
                className="mb-2"
              >
                <TooltipComponent
                  position="bottom"
                  text={
                    <p className="mb-0 text-start">
                      For this transfer, the exchange rate isn't guaranteed -
                      Wise will use the exchange rate at the moment of receiving
                      your money
                      <a
                        href="#"
                        target="_blank"
                        className="d-block text-decoration-underline"
                      >
                        Learn more
                      </a>
                    </p>
                  }
                  btnText={
                    <Button className="bg-transparent text-start border-0 p-0 text-800 lh-1 shadow-none text-decoration-underline d-md-block d-none">
                      Exchange rate (Not guaranteed)
                    </Button>
                  }
                />
                <Button
                  onClick={() => setShow(true)}
                  className="bg-transparent text-start border-0 p-0 text-800 lh-1 shadow-none text-decoration-underline d-md-none "
                >
                  Exchange rate (Not guaranteed)
                </Button>
                <p className="mb-0">32.7730</p>
              </Flex>
              <ReviewItem
                title="You get"
                value={
                  <span className="mb-0">{thousandSeparator(160662)} KES</span>
                }
              />
              <ReviewItem title="Should arrive" value="in 15 minutes" />
            </div>

            <hr />

            <div>
              <p className="fs-1 fw-semi-bold text-1000">Recipient details</p>
              <ReviewItem title="Name" value="Hillary Kiprono Langat" />
              <ReviewItem title="Email" value="langat.paponya@gmail.com" />
              <ReviewItem title="Beneficiary's bank" value="07" />
              <ReviewItem title="Account number" value="1003337018" />
            </div>
          </div>
          <Flex direction="column" className="w-100 gap-3 mt-4">
            <Button variant="primary" className="rounded-5 p-2 h-48px">
              Continue to payment
            </Button>
            <Button variant="outline-danger" className="rounded-5 p-2 h-48px">
              Cancel this transfer
            </Button>
          </Flex>
          <a
            className="mt-3 d-block text-1000 text-decoration-underline fw-semi-bold"
            href="#"
          >
            Looking for a different way to pay?
          </a>
        </Col>
      </Row>
      <Offcanvas
        show={show}
        placement={'bottom'}
        onHide={() => setShow(false)}
        className="c-offcanvas-style"
      >
        <div className="offcanvas-close-line" />

        <Offcanvas.Body className="mt-4">
          <p className="mb-0 px-3 text-start">
            For this transfer, the exchange rate isn't guaranteed - Wise will
            use the exchange rate at the moment of receiving your money
            <a
              href="#"
              target="_blank"
              className="d-block text-decoration-underline"
            >
              Learn more
            </a>
          </p>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default PayTransfer;
